import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const ReservedRedux = createActions(
  {
    reservedRequest: ['studentId', 'data'],
    reservedSuccess: ['data'],
    reservedFailure: ['errors'],
  },
  {
    prefix: 'RESERVED_',
    defaultActions: {
    },
  },
)

const { Types, Creators } = ReservedRedux
export const ReservedTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
})

/* ------------- Reducers ------------- */

const reservedRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  new_reserved: {
    error: '',
    success: false,
  },
}, d)

const reservedSuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  new_reserved: {
    error: '',
    success: true,
  },
  ...data,
}, d)

const reservedFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
    error: errors,
  },
  new_reserved: {
    success: false,
    error: errors[0],
  },
}, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.reservedRequest]: reservedRequest,
    [Types.reservedSuccess]: reservedSuccess,
    [Types.reservedFailure]: reservedFailure,
  },
  {
    defaultActions: {
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ReservedRedux.js